







import {Component, Prop, Vue} from 'vue-property-decorator';
import VueAsyncComputed from 'vue-async-computed';
import AsyncComputedProp from 'vue-async-computed-decorator';
import {ArkStatsBackendClient, DinoDto} from '@/logic/ark-stats-backend/ArkStatsBackendClient';

Vue.use(VueAsyncComputed);

@Component({
    components: {}
})
export default class DinoName extends Vue {

    @Prop({required: true})
    dinoId!: string | number;

    @AsyncComputedProp()
    public async object(): Promise<{ id?: string, name?: string } | null> {
        if (!this.dinoId) {
            return null;
        }
        const result = await ArkStatsBackendClient.getDinos({
            limit: 1,
            fields: ['name'],
            filter: `id==${this.dinoId}`
        });
        if (!result.data || !result.data.length) {
            return {
                id: String(this.dinoId),
                name: String(this.dinoId)
            }
        }

        return result.data[0];
    }
}
